"use client";

import { useEffect } from "react";
import posthog from "posthog-js";
import { useCurrentUserId } from "@/contexts/customer-id-context";

/**
 * PostHog boots in `cookieless_mode: "on_reject"`, which captures nothing until
 * consent is resolved either way. Being logged in is what resolves it: logged-out
 * visitors are opted out and counted through PostHog's server-side hash without
 * cookies or local storage, logged-in users are opted in so identify(), groups,
 * session recording and feature flags work.
 *
 * Both opt calls re-emit the initial pageview, so deciding this after hydration
 * costs nothing. The user id comes from the JWT via SSR, so it is there on the
 * first render.
 */
export function PosthogConsent() {
  const userId = useCurrentUserId();

  useEffect(() => {
    if (!posthog.__loaded) return;

    const consent = posthog.get_explicit_consent_status();

    if (userId) {
      if (consent !== "granted") posthog.opt_in_capturing({ captureEventName: false });
    } else if (consent !== "denied") {
      posthog.opt_out_capturing();
    }
  }, [userId]);

  return null;
}
